import { CurrencyType } from "../../../enums/currencyType";
import { FieldType } from "../../../enums/fieldType";
import { TriggerTargetDto } from "../actionTriggers/triggerTargetDto";
import { CalculationDto } from "../calculations/calculationDto";
import { FieldDto } from "./fieldDto";

class CalculatedFieldDto extends FieldDto {

    public fieldType: FieldType = FieldType.Calculated;

    public currencyType: CurrencyType;

    public target: TriggerTargetDto;

    public calculations: CalculationDto[] = [];

    get currencySymbol() {
        switch (this.currencyType) {
            case CurrencyType.EUR: return "€";
            case CurrencyType.GBP: return "£";
            case CurrencyType.USD: return "$";
            default: return "";
        }
    }
}

export { CalculatedFieldDto };